import _extends from "@babel/runtime/helpers/extends";
import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import { radioLabelStyles } from './styles';
import { RadioButton } from '../FormElements';
import { ConversionOptionsContainer, IofDisclosure } from './StyledComponents';
import { PayPalDisclosures, TotalAmount, VendorDisclosure } from './Components';

var CurrencyConversionOptions = props => {
  var {
    selectedConversionOption,
    styleOverrides
  } = props;
  var isPayPalSelected = selectedConversionOption === 'PAYPAL';
  var Disclosures = isPayPalSelected ? PayPalDisclosures : VendorDisclosure;
  var disclosureStyleOverrides = isPayPalSelected ? styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.paypalDisclosure : styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.vendorDisclosure;
  return jsx(Fragment, null, jsx(ConversionOptionsContainer, {
    css: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.optionsContainer
  }, props.conversionOptions.map(_ref => {
    var _props$styleOverrides, _props$styleOverrides2;

    var {
      id,
      label,
      value
    } = _ref;
    return jsx(RadioButton, _extends({}, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.radioButton, {
      blurHandler: props.blurHandler,
      changeHandler: props.changeHandler,
      checked: value === selectedConversionOption,
      focusHandler: props.focusHandler,
      id: id || "xo-rc-currency-conversion-option-".concat(value),
      key: value,
      label: label,
      labelStyleOverrides: [radioLabelStyles, (_props$styleOverrides = props.styleOverrides) === null || _props$styleOverrides === void 0 ? void 0 : (_props$styleOverrides2 = _props$styleOverrides.radioButton) === null || _props$styleOverrides2 === void 0 ? void 0 : _props$styleOverrides2.labelStyleOverrides],
      name: props.inputName || 'currencyConversion',
      value: value
    }));
  })), jsx(TotalAmount, _extends({
    isPayPalSelected: isPayPalSelected,
    styleOverrides: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.totalAmount
  }, props.total)), jsx(Disclosures, _extends({
    styleOverrides: disclosureStyleOverrides
  }, props.disclosures)), props.iofDisclosure && jsx(IofDisclosure, {
    css: styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.iofDisclosure
  }, props.iofDisclosure));
};

CurrencyConversionOptions.defaultProps = {
  styleOverrides: {}
};
export { CurrencyConversionOptions };